import { FunctionComponent } from "react";
import styles from "./SuccessContainer.module.css";
const SuccessContainer: FunctionComponent = () => {
  return (
    <div className={styles.body}>
      <div className={styles.content3}>
        <div className={styles.divelementorFlipBoxLayer}>
          <div className={styles.div}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg1311111.svg" />
            <div className={styles.h3elementorFlipBoxLayer}>
              <div className={styles.freeHelpCoursesContainer}>
                <p className={styles.freeHelpCourses}>Free help courses</p>
                <p className={styles.freeHelpCourses}>and support</p>
              </div>
            </div>
            <div className={styles.getStarted}>Get started</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer2}>
          <div className={styles.div1}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg211111.svg" />
            <div className={styles.h3elementorFlipBoxLayer1}>
              <div className={styles.freeHelpCoursesContainer}>
                <p className={styles.freeHelpCourses}>Advanced marketing</p>
                <p className={styles.freeHelpCourses}>and sales reporting</p>
              </div>
            </div>
            <div className={styles.getStarted}>Check results</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer4}>
          <div className={styles.div2}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg311111.svg" />
            <div className={styles.h3elementorFlipBoxLayer2}>
              <div className={styles.freeHelpCoursesContainer}>
                <p className={styles.freeHelpCourses}>Excellent email</p>
                <p className={styles.freeHelpCourses}>deliverability</p>
              </div>
            </div>
            <div className={styles.getStarted}>Send better</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer6}>
          <div className={styles.div3}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg41111.svg" />
            <div className={styles.h3elementorFlipBoxLayer3}>
              <div className={styles.freeHelpCoursesContainer}>
                <p className={styles.freeHelpCourses}>
                  Gmail and Outlook inbox
                </p>
                <p className={styles.freeHelpCourses}>extensions</p>
              </div>
            </div>
            <div className={styles.getStarted}>Manage inbox</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer8}>
          <div className={styles.div4}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg51111.svg" />
            <div className={styles.landingPages}>Landing pages</div>
            <div className={styles.getStarted}>Start building</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer10}>
          <div className={styles.div5}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg611111.svg" />
            <div className={styles.landingPages}>Pre-built automations</div>
            <div className={styles.getStarted}>Target contacts</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer12}>
          <div className={styles.div2}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg711111.svg" />
            <div className={styles.h3elementorFlipBoxLayer4}>
              <div className={styles.freeHelpCoursesContainer}>
                <p className={styles.freeHelpCourses}>Integrated and</p>
                <p className={styles.freeHelpCourses}>embeddable forms</p>
              </div>
            </div>
            <div className={styles.getStarted}>Make forms</div>
          </div>
        </div>
        <div className={styles.divelementorFlipBoxLayer14}>
          <div className={styles.div7}></div>
          <div className={styles.divelementorFlipBoxLayer1}>
            <img className={styles.svgIcon} alt="" src="/svg81111.svg" />
            <div className={styles.landingPages}>CRM</div>
            <div className={styles.getStarted}>Automate sales</div>
          </div>
        </div>
        <div className={styles.everythingYouNeedContainer}>
          <span className={styles.everythingYouNeedContainer1}>
            <p className={styles.freeHelpCourses}>
              Everything you need to make the
            </p>
            <p className={styles.freeHelpCourses}>path to success shorter</p>
          </span>
        </div>
      </div>
      <img className={styles.bodyChild} alt="" src="/frame-73511.svg" />
    </div>
  );
};

export default SuccessContainer;
